import { useEffect, useMemo, useState } from "react";
import FormComp from "../../Componentes/FormComp";
import Overlay from "../../Componentes/Overlay";
import Formulario from "../../Componentes/Utils/Formulario";
import Modal from "../../Componentes/Utils/Modal";
import { useToast } from "../../contexts/ToastContext";
import { useModal } from "../../contexts/ModalContext";
import { formatValorMoney } from "../../Funcoes/FormatValorMoney";
import SmallLoading from "../../Componentes/Utils/SmallLoading";
import { useParams } from "react-router-dom";
import useApi from "../../hooks/useApi";

const addDaysISO = (isoDate, days) => {
    if (!isoDate) return '';
    const base = new Date(`${isoDate}T00:00:00`);
    base.setDate(base.getDate() + days);
    const yyyy = base.getFullYear();
    const mm = String(base.getMonth() + 1).padStart(2, '0');
    const dd = String(base.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

const ModalAddFolga = ({ info, fetchData }) => {

    const { matricula } = useParams();

    const { notifySuccess, notifyError } = useToast();
    const { closeModal } = useModal();

    const api = useApi();

    const [loading, setLoading] = useState(true);
    const [parametros, setParametros] = useState({});

    const [dataFolga, setDataFolga] = useState('');
    const [dataPagamento, setDataPagamento] = useState('');

    const fetchInfo = async () => {

        setLoading(true);

        try {

            const { data } = await api.post('/Painel/API/Colaborador/GetDistance/', {
                "centro_custo": info.CENTRO_CUSTO,
                "municipio": info.MUNICIPIO,
                "estado": info.ESTADO
            })

            setParametros(data);

        } catch (e) {

            console.log(e);
            notifyError(e?.response?.data?.message || "Não foi possível carregar os dados da folga.");
            closeModal();

        } finally {

            setLoading(false)

        }

    }

    useEffect(() => {

        fetchInfo();

    }, [])

    const diasViagem = useMemo(() => {
        const dist = Number(parametros?.distancia ?? 0);
        return dist < 300 ? 1 : 4;
    }, [parametros]);

    const dataRetornoPrevista = useMemo(() => {
        if (!dataFolga) return '';
        const incremento = (Number(parametros?.gozo_dias) || 0) + diasViagem - 1;
        return addDaysISO(dataFolga, incremento);
    }, [dataFolga, parametros, diasViagem]);

    const handleChangeDataFolga = (value) => {
        setDataFolga(value);
        if (value) {
            setDataPagamento(addDaysISO(value, -60));
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {

            await api.post('/Painel/API/Colaborador/SaveNewFolga/', {
                matricula,
                data_folga: dataFolga,
                data_pagamento: dataPagamento,
            });

            await fetchData();
            notifySuccess("Folga de campo adicionada com sucesso.");
            closeModal();

        } catch (e) {

            console.log(e);
            const msg = e?.response?.data?.message || "Erro ao salvar folga de campo!";
            notifyError(msg);

        } finally {

            setLoading(false);

        }
    }

    return (
        <>
            <Overlay state={true} >
                <Modal size="md" header={true} close={closeModal} >
                    <Formulario onSubmit={(e) => handleSubmit(e)} >
                        <FormComp
                            title="VALOR"
                            type="text"
                            valor={formatValorMoney(parametros.valor)}
                            readOnly
                        />
                        <FormComp
                            title="DIAS GOZO"
                            type="text"
                            valor={parametros.gozo_dias}
                            readOnly
                        />
                        <FormComp
                            title="DATA INÍCIO FOLGA"
                            type="date"
                            valor={dataFolga}
                            changeFunc={(e) => handleChangeDataFolga(e.target.value)}
                            required
                        />
                        <FormComp
                            title="DATA DE RETORNO"
                            type="date"
                            valor={dataRetornoPrevista}
                            readOnly
                        />
                        <FormComp
                            title="DATA DO PAGAMENTO"
                            type="date"
                            valor={dataPagamento}
                            changeFunc={(e) => setDataPagamento(e.target.value)}
                            required
                        />
                        <FormComp
                            type="submit"
                            valor="SALVAR"
                        />
                    </Formulario>
                </Modal>
            </Overlay>
            {loading && (
                <Overlay state={true} >
                    <Modal>
                        <SmallLoading />
                    </Modal>
                </Overlay>
            )}
        </>
    )
}

export default ModalAddFolga;
